export const GET_LIST_CHANNEL_ORDER = 'GET_LIST_CHANNEL_ORDER'
export const GET_LIST_CHANNEL_ORDER_SUCCESS = 'GET_LIST_CHANNEL_ORDER_SUCCESS'

export const resetSumaryOrder = payload => ({
    type: 'RESET_SUMARY_ORDER',
})

export const onLoadOrders = payload => ({
    type: 'ON_LOAD_ORDERS',
    payload,
})
export const addFilter = () => ({
    type: 'ADD_FILTER',
})

export const onChange = payload => ({
    type: 'ON_CHANGE',
    payload,
})
export const onSubmit = payload => ({
    type: 'ON_SUBMIT',
    payload,
})
export const update = (payload) => ({
    type: 'UPDATE_ORDER_LIST',
    payload
})
export const onReset = (payload) => ({
    type: 'ON_RESET_ORDER_FILTER',
    payload
})
export const closeFilter = (payload) => ({
    type: 'CLOSE_FILTER_ORDER',
    payload
})

export const onSort = payload => ({
    type: 'ON_SORT',
    payload,
})

export const onCheck = payload => ({
    type: 'ON_CHECK_ORDER',
    payload,
})
export const onCheckAll = payload => ({
    type: 'ON_CHECK_ALL_ORDER',
    payload,
})

export const onSortOrdersSuccess = payload => ({
    type: 'ON_SORT_ORDERS_SUCCESS',
    payload,
})

export const onSortOrdersFailure = payload => ({
    type: 'ON_SORT_ORDERS_FAILURE',
    payload,
})
export const getOrdersByPage = payload => ({
    type: 'ON_GET_ORDERS_BY_PAGE',
    payload,
})

export const onChangeOffset = payload => ({
    type: 'ON_CHANGE_OFFSET_ORDER_LIST',
    payload,
})
export const nextOrBack = payload => ({
    type: 'ON_NEXT_OR_BACK_ORDER',
    payload,
})
export const onRemoveFilter = payload => ({
    type: 'ON_REMOVE_FILTER_ORDER',
    payload,
})
export const onTab = payload => ({
    type: 'ON_TAB_ORDER',
    payload,
})
export const createShipment = payload => ({
    type: 'ON_CREATE_SHIPMENT',
    payload,
})
export const createShipmentSuccess = payload => ({
    type: 'CREAT_SHIPMENT_SUCCESS',
    payload,
})
export const createShipmentFailure = payload => ({
    type: 'CREAT_SHIPMENT_FAILURE',
    payload,
})
export const onOk = () => ({
    type: 'ON_OK_CREATE_SHIPMENT',
})
export const deleteOrder = (payload) => ({
    type: 'ON_DELETE_ORDER',
    payload
})

export const getListChannelOrder = (payload) => {
    return {
        type: 'GET_LIST_CHANNEL_ORDER',
        payload
    }
}

export const getListChannelOrderSuccess = (payload) => {
    return {
        type: 'GET_LIST_CHANNEL_ORDER_SUCCESS',
        payload
    }
}

export const getSplitedOrder = (payload) => {
    return {
        type: 'GET_SPLIT_ORDER',
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/ordersAction.js